// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TiktokBioRouteImport } from './routes/tiktok-bio'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as RobloxBioRouteImport } from './routes/roblox-bio'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as EsRouteImport } from './routes/es'
import { Route as DiscordBioRouteImport } from './routes/discord-bio'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as IndexRouteImport } from './routes/index'

const TiktokBioRoute = TiktokBioRouteImport.update({
            id: '/tiktok-bio',path: '/tiktok-bio',getParentRoute: () => rootRouteImport
          })
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })
const RobloxBioRoute = RobloxBioRouteImport.update({
            id: '/roblox-bio',path: '/roblox-bio',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const EsRoute = EsRouteImport.update({
            id: '/es',path: '/es',getParentRoute: () => rootRouteImport
          })
const DiscordBioRoute = DiscordBioRouteImport.update({
            id: '/discord-bio',path: '/discord-bio',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutUsRoute: AboutUsRoute,ContactUsRoute: ContactUsRoute,DiscordBioRoute: DiscordBioRoute,EsRoute: EsRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RobloxBioRoute: RobloxBioRoute,TermsOfServiceRoute: TermsOfServiceRoute,TiktokBioRoute: TiktokBioRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)